import serverApi from './serverAPIConfig'

export default {
    ...serverApi,
    skipFixers: true
}
